/**************
 Cart
 ***************/

let engravingVariantID = 51222995108071;

// Fetch data about items in cart
// - variantIDToSellingPlanID
// - variantIDToSellingPlanName
async function getCartItemsData() {
    return await fetch("/cart?view=item-data")
        .then(response => response.json())
        .then(data => {
            return data;
        });
}

// scroll position used before and after opening the cart
let currentScrollPosition = 0;

// open cart
async function openCart(skipFetch = false) {
    // open cart
    currentScrollPosition = window.scrollY;
    document.querySelector("#miniCart").showModal();
    document.querySelector("html").classList.add("lock");

    // hide all sections
    document.querySelector("#miniCartEmpty").classList.remove("active");
    document.querySelector("#miniCartBody").classList.remove("active");
    document.querySelector("#miniCartFooter").classList.remove("active");
    document.querySelector('.miniCartBodyItem.engraving').classList.remove("active");

    // start loading on the cart
    document.querySelector("#miniCartContent").classList.add("loading");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // remove protection or free containers
    if (cartSettings.protection_upsell) {
        // create update payload
        let updatePayload = {};

        // get all protection items
        cart.items.forEach(item => {
            if (item.variant_id === cartSettings.protection_upsell.variants[0].id) {
                updatePayload[item.key] = 0;
            }
        });

        // check if we need to update the cart
        if (Object.keys(updatePayload).length > 0) {
            cart = await updateCart({updates: updatePayload});
            await openCart(true);
            return;
        }
    }

    // check if engraving product in cart
    let engravingInCart = false;
    cart.items.forEach(item => {
        if (item.variant_id === engravingVariantID) {
            engravingInCart = item;
        }
    })
    if (engravingInCart) {
        // remove engraving item from cart
        let updatePayload = {};
        updatePayload[engravingInCart.key] = 0;
        cart = await updateCart({updates: updatePayload});
        await openCart(true);
        return;
    }

    // check if any cart items have the property Engraving, if so make sure it's 14 characters or fewer
    cart.items.forEach(item => {
        if (item.properties && item.properties.Engraving) {
            if (item.properties.Engraving.length > 14) {
                (async () => {
                    // remove the product and notify the user
                    let updatePayload = {};
                    updatePayload[item.key] = 0;
                    cart = await updateCart({updates: updatePayload});
                    await Swal.fire({
                        target: document.querySelector('#miniCart'),
                        title: "Engraving Too Long",
                        text: "We're sorry, but the engraving text you provided exceeds the maximum length of 14 characters. The item has been removed from your cart. Please adjust your engraving text and try again.",
                        icon: "error",
                        confirmButtonText: "OK"
                    });
                    await openCart();
                })()
            }
        }
    })

    // stop loading on the cart
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelector('#headerIconsCart').setAttribute("data-count", cart.item_count);
    document.querySelector("#miniCartHeaderTitle").textContent = `Your Cart (${cart.item_count})`;

    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartUpsell").classList.add("active");


    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");

        // show first two upsells
        document.querySelectorAll(".miniCartUpsellItem").forEach((element, index) => {
            if (index < 2) {
                element.classList.add("active");
            } else {
                element.classList.remove("active");
            }
        });
        return;
    }


    // show main cart sections
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");


    // check if engraving in cart
    let engravingsInCart = 0;
    cart.items.forEach(item => {
        if (item.properties && item.properties.Engraving) {
            engravingsInCart += item.quantity;
        }
    });

    // if there are engravings in the cart, show the engraving item
    let engravingPrice = 0;
    if (engravingsInCart > 0) {
        let engravingItem = document.querySelector('.miniCartBodyItem.engraving');
        engravingPrice = parseInt(engravingItem.querySelector('.miniCartBodyItemPrice').dataset.price) * engravingsInCart;
        engravingItem.querySelector('.miniCartBodyItemQuantityCount').textContent = engravingsInCart;
        engravingItem.querySelector('.miniCartBodyItemPrice').textContent = price(engravingPrice, true);
        engravingItem.classList.add("active");
    }


    // check how many subscription items are in the cart, including quantity
    let subscriptionItems = 0;
    cart.items.forEach(item => {
        if (item.selling_plan_allocation) {
            subscriptionItems += item.quantity;
        }
    });

    // Free shipping for subscription
    if (cartSettings.free_shipping_method === "subscription") {
        if (subscriptionItems > 0) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "Upgrade to a subscription for <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
        }
    }


    document.querySelector('#miniCartBodyItems').classList.remove("singleItem");

    // Check if cart contains just 1 item
    if (cart.item_count === 1) {
        // add special padding class
        document.querySelector('#miniCartBody').classList.add("singleItem");
    }

    // Free shipping for price threshold
    let freeShippingThreshold = parseInt(cartSettings.free_shipping_threshold * 100);
    if (cartSettings.free_shipping_method === "threshold") {
        if (cart.total_price >= freeShippingThreshold) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = `Spend<b> ${price(freeShippingThreshold - cart.total_price)}</b> more for <b>FREE SHIPPING</b>`;
            document.querySelector("#miniCartHeaderBarInner").style.width = `${(cart.total_price / freeShippingThreshold) * 100}%`;
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
        }
    }

    // get cart item data
    let cartData = await getCartItemsData();
    let variantIDToSellingPlanName = cartData.variantIDToSellingPlanName;
    let variantIDToSellingPlanID = cartData.variantIDToSellingPlanID;
    let variantIDToCompareAtPrice = cartData.variantIDToCompareAtPrice;

    // reset body container
    document.querySelector("#miniCartBodyItems").innerHTML = "";

    // append cart
    cart.items.forEach(function (item) {
        const hasProperties = item.properties && Object.keys(item.properties).length > 0;

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        // property HTML
        function propertiesHTML() {
            // check for any properties
            if (!hasProperties) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties">`;
            for (const key in item.properties) {
                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                    continue;
                }
                if (typeof key === "string" && key.startsWith("_")) {
                    continue;
                }

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // price HTML
        function priceHTML() {
            let HTML = "";

            /****************** discount ******************/

            let comparePrice = null
            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrice = item.selling_plan_allocation.compare_at_price * item.quantity;
            }
            // check for line item discount
            else if (item.original_line_price > item.final_line_price) {
                comparePrice = item.original_line_price;
            }
            // check for compare at price
            else if (variantIDToCompareAtPrice[item.variant_id] > item.final_price) {
                comparePrice = variantIDToCompareAtPrice[item.variant_id] * item.quantity;
            }

            // check if comparePrice exists
            if (comparePrice) {
                HTML += `<s class="igComparePrice" data-price-multiplier="${item.quantity}" data-variant-id="${item.variant_id}">${price(comparePrice, false)}</s>`;
            }

            /****************** actual price ******************/

            HTML += price(item.final_line_price, false);

            /***************** savings *****************/

            // check for savings
            if (comparePrice) {
                let igSavings = parseFloat(window.igData?.price?.getComparePriceByVariantId(item.variant_id) * 100 * item.quantity) || comparePrice;
                let savings = igSavings - item.final_line_price;
                if (savings > 0) {
                    HTML += `<span>(Save ${price(savings, false)})</span>`;
                }
            }

            return HTML;
        }

        // upgrade button HTML
        function upgradeHTML() {

            // check if already a subscription
            if (item.selling_plan_allocation) {
                return "";
            }

            // get selling plan id and name
            let sellingPlanID = variantIDToSellingPlanID[item.variant_id];
            let sellingPlanName = variantIDToSellingPlanName[item.variant_id];

            // check if selling plan exists
            if (!sellingPlanID) {
                return "";
            }

            // return HTML
            return `
                <button 
                    class="miniCartBodyItemUpgrade button"
                     data-key="${item.key}"
                     data-quantity="${item.quantity}" 
                     data-plan="${sellingPlanID}"
                >
               ${sellingPlanName}
                </button>
            `;
        }

        // insert item
        document.querySelector("#miniCartBodyItems").insertAdjacentHTML("beforeend", `
        <div class="miniCartBodyItem" key="${item.key}">
            <img class="miniCartBodyItemImage" src="${item.image}&width=200">
            <div>
                <div class="miniCartBodyItemFlex">
                    <div>
                        <div class="miniCartBodyItemTitle">${item.product_title}</div>
                        ${variantHTML()}
                        ${propertiesHTML()}
                        ${subscriptionHTML()}
                    </div>
                    <button class="miniCartBodyItemRemove">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 329.26933 329" width="16px" height="12px"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"></path></svg>
                    </button>
                </div>
                <div class="miniCartBodyItemFlex marginTop">
                    <div class="miniCartBodyItemQuantity">
                        <button class="miniCartBodyItemQuantityMinus">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" viewBox="0 -192 469.33333 469">
                          <path d="m437.332031.167969h-405.332031c-17.664062 0-32 14.335937-32 32v21.332031c0 17.664062 14.335938 32 32 32h405.332031c17.664063 0 32-14.335938 32-32v-21.332031c0-17.664063-14.335937-32-32-32zm0 0">
                          </path>
                        </svg>
                        </button>
                        <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                        <button class="miniCartBodyItemQuantityPlus">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" version="1.1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve"> <g> <g>
                          <path d="M465.064,207.566l0.028,0H284.436V27.25c0-14.84-12.016-27.248-26.856-27.248h-23.116    c-14.836,0-26.904,12.408-26.904,27.248v180.316H26.908c-14.832,0-26.908,12-26.908,26.844v23.248    c0,14.832,12.072,26.78,26.908,26.78h180.656v180.968c0,14.832,12.064,26.592,26.904,26.592h23.116    c14.84,0,26.856-11.764,26.856-26.592V284.438h180.624c14.84,0,26.936-11.952,26.936-26.78V234.41    C492,219.566,479.904,207.566,465.064,207.566z">
                          </path> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g>
                        </svg>
                        </button>
                    </div>
                    <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                </div>
            </div>
            ${upgradeHTML()}
        </div>
        `);

    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus")?.addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus")?.addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove")?.addEventListener("click", function () {
            quantity = 0;
            updateCartItem();

            // fade out and remove
            element.classList.add("fade");
            setTimeout(() => {
                element.remove();
            }, 500);
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            document.querySelector("#miniCartContent").classList.add("loading");

            // update cart in shopify
            cart = await changeCart({
                id: key,
                quantity: quantity
            });

            // update active body
            await openCart(true);
        }

        // listen for upgrade button click
        element.querySelector(".miniCartBodyItemUpgrade")?.addEventListener("click", async function () {
            const key = this.dataset.key;
            const quantity = parseInt(this.dataset.quantity);
            const sellingPlanID = parseInt(this.dataset.plan);

            // add loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // add selling plan
            cart = await changeCart({
                id: key,
                quantity: quantity,
                selling_plan: sellingPlanID
            });

            await openCart(true);

            // remove loading animation
            document.querySelector("#miniCartContent").classList.remove("loading");
        });
    });

    // check if cart contains an upsell item
    document.querySelectorAll(".miniCartUpsellItem").forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.product);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);

        // hide if already in the cart
        if (isProductInCart) {
            element.classList.remove("active");
        } else {
            element.classList.add("active");
        }
    });

    // check if all upsells are hidden
    if (document.querySelectorAll(".miniCartUpsellItem.active").length === 0) {
        document.querySelector("#miniCartUpsell").classList.remove("active");
    }

    // add protection price if checked
    if (document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.checked) {
        document.querySelector("#miniCartFooterTotalPriceReal").textContent = price(cart.items_subtotal_price + cartSettings.protection_upsell.variants[0].price + engravingPrice);
    } else {
        document.querySelector("#miniCartFooterTotalPriceReal").textContent = price(cart.items_subtotal_price + engravingPrice);
    }

    // calculate the maximum compare at price
    let totalComparePrice = 0;
    cart.items.forEach(item => {
        // find variant compare at price
        let comparePrice = parseFloat(window.igData?.price?.getComparePriceByVariantId(item.variant_id)) * 100 || variantIDToCompareAtPrice[item.variant_id];
        if (comparePrice > item.original_price) {
            totalComparePrice += comparePrice * item.quantity;
        } else {
            totalComparePrice += item.original_line_price;
        }

        // add engraving price
        totalComparePrice += engravingPrice;
    });

    let totalPrice = cart.items_subtotal_price + engravingPrice;

    // update compare price
    if (totalComparePrice > totalPrice) {
        document.querySelector("#miniCartFooterTotalPriceCompare").textContent = price(totalComparePrice);

        // calculate savings percentage
        let savings = totalComparePrice - totalPrice;
        document.querySelector("#miniCartFooterTotalPriceSave").textContent = `(${price(savings)} SAVED)`;

    } else {
        document.querySelector("#miniCartFooterTotalPriceCompare").textContent = "";
        document.querySelector("#miniCartFooterTotalPriceSave").textContent = "";
    }

    // check if price or compare price is ? $1,000
    // if so make the text smaller
    document.querySelector("#miniCartFooterTotal").classList.remove("small");
    let priceOverflowing = totalComparePrice > 99999 || totalPrice > 99999
    if (priceOverflowing) {
        document.querySelector("#miniCartFooterTotal").classList.add("small");
    }

    // if it's mobile and both are > 1000, make even smaller
    document.querySelector("#miniCartFooterTotal").classList.remove("smaller");
    if (totalComparePrice > 99999 && totalPrice > 99999 && window.innerWidth < 800) {
        document.querySelector("#miniCartFooterTotal").classList.add("smaller");
    }
}

// listen for upsell select
document.querySelectorAll('.miniCartUpsellItemWrapSelect')?.forEach(function (element) {
    element.addEventListener("change", function () {
        // update image
        let upsell = this.closest('.miniCartUpsellItem');
        upsell.querySelector('.miniCartUpsellItemWrapImg').src = this.value;

        // update the popup select
        // find the correct popup
        let target = this.dataset.target;
        let popup = document.querySelector(`#${target}`);

        popup.querySelector(`.variantUpsellOptionsSelect`).value = element.options[element.selectedIndex].dataset.variant;

        // make sure the correct image is shown (if it exists)
        let variant = JSON.parse(element.options[element.selectedIndex].dataset.variant);
        if (variant.featured_image) {
            popup.querySelector('.variantUpsellHeaderImg').src = variant.featured_image.src;
        } else {
            popup.querySelector('.variantUpsellHeaderImg').src = this.value;
        }

        // update price
        upsell.querySelector('.miniCartUpsellItemWrapBodyPriceReal').textContent = price(variant.price);
        upsell.querySelector('.miniCartUpsellItemWrapBodyPriceCompare').textContent = '';

        popup.querySelector('.variantUpsellHeaderInfoVariant').textContent = variant.title;
        popup.querySelector('.variantUpsellPriceReal').textContent = price(variant.price);
        popup.querySelector('.variantUpsellPriceReal').setAttribute("data-variant-id", variant.id);
        popup.querySelector('.variantUpsellPriceCompare').textContent = "";
        if (variant.compare_at_price > variant.price) {
            popup.querySelector('.variantUpsellPriceCompare').textContent = price(variant.compare_at_price);
            popup.querySelector('.variantUpsellPriceCompare').setAttribute("data-variant-id", variant.id);

            upsell.querySelector('.miniCartUpsellItemWrapBodyPriceCompare').textContent = price(variant.compare_at_price);
        }


    });
});


// Add Upsell function
document.querySelectorAll('.miniCartUpsellItemWrapATC').forEach(function (element) {
    element.addEventListener("click", async function () {

        // if this upsell has variants, open the variant selector
        if (element.classList.contains('openVariants')) {
            return;
        }

        // get variant ID from dropdown selector
        const variantID = this.closest('.miniCartUpsellItem').dataset.variant;

        // add loading animation
        document.querySelector("#miniCartContent").classList.add("loading");

        // create form data
        let formData = {
            items: [{
                quantity: 1,
                id: variantID,
            }]
        };

        // check for selling plan
        if (this.closest('.miniCartUpsellItem').dataset.plan) {
            let sellingPlanID = this.closest('.miniCartUpsellItem').dataset.plan;
            formData = {
                items: [{
                    quantity: 1,
                    id: variantID,
                    selling_plan: sellingPlanID
                }]
            };
        }

        // add product upsell
        await addProduct(formData);

        // track
        window.igEvents = window.igEvents || [];
        window.igEvents.push({
            "event": "added_to_cart_cart"
        })

        // remove loading animation
        document.querySelector("#miniCartContent").classList.remove("loading");

        await openCart();
    });
});


// listen for protection plan switch
document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.addEventListener("change", async function () {
    await openCart(true);
});

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("html").classList.remove("lock");
    // scroll to previous position
    window.scrollTo(0, currentScrollPosition);
});


// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function () {
        openCart();
    });
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // formdata
    let formData = {
        items: []
    };

    // check if protection product is checked - if so atc
    if (document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.checked) {
        // add protection product
        formData.items.push({
            quantity: 1,
            id: cartSettings.protection_upsell.variants[0].id,
        });
    }

    // check if engraving in cart
    let engravingsInCart = 0;
    cart.items.forEach(item => {
        if (item.properties && item.properties.Engraving) {
            engravingsInCart += item.quantity;
        }
    });

    if (engravingsInCart > 0) {
        // add engraving product
        formData.items.push({
            quantity: engravingsInCart,
            id: engravingVariantID
        });
    }

    // add to cart
    if (formData.items.length > 0) {
        await addProduct(formData);
    }

    // Navidium
    await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            attributes: {
                _nvd_opted_in: 1
            }
        })
    });


    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;

    // wait 1s
    await new Promise(r => setTimeout(r, 1000));

    // remove loading animation
    this.classList.remove("loading");
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));

/**************
 Variant upsells
 *************/

// close event
document.querySelectorAll(".variantUpsell")?.forEach(function (element) {
    element.addEventListener("close", function () {
    });
});

// open gallery event listener
document.querySelectorAll(".openVariants")?.forEach(function (element) {
    element.addEventListener("click", function () {
        let target = this.dataset.target;
        document.querySelector(`#${target}`).showModal();
    });
});

//close gallery event listener
document.querySelectorAll(".variantUpsellClose")?.forEach(function (element) {
    element.addEventListener("click", function () {
        let target = this.dataset.target;
        document.querySelector(`#${target}`).close();
    });
});

document.querySelectorAll(".variantUpsell")?.forEach(function (element) {
    element.addEventListener("click", function (e) {
        if (e.target === this) {
            this.close();
        }
    });
})

// register dialog
// wait for document to load first
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("dialog.variantUpsell")?.forEach(function (element) {
        dialogPolyfill.registerDialog(element);
    });
});

// listen for select change
document.querySelectorAll('.variantUpsellOptionsSelect')?.forEach(function (element) {
    element.addEventListener("change", function () {
        let variant = JSON.parse(this.value);

        // update image
        if (variant.featured_image) {
            this.closest('.variantUpsell').querySelector('.variantUpsellHeaderImg').src = variant.featured_image.src;
        } else {
            this.closest('.variantUpsell').querySelector('.variantUpsellHeaderImg').src = this.closest('.variantUpsell').dataset.fallback;
        }

        // update price
        this.closest('.variantUpsell').querySelector('.variantUpsellPriceReal').textContent = price(variant.price);
        this.closest('.variantUpsell').querySelector('.variantUpsellPriceReal').setAttribute("data-variant-id", variant.id);
        this.closest('.variantUpsell').querySelector('.variantUpsellPriceCompare').textContent = "";
        if (variant.compare_at_price > variant.price) {
            this.closest('.variantUpsell').querySelector('.variantUpsellPriceCompare').textContent = price(variant.compare_at_price);
            this.closest('.variantUpsell').querySelector('.variantUpsellPriceCompare').setAttribute("data-variant-id", variant.id);
        }

        // update title
        this.closest('.variantUpsell').querySelector('.variantUpsellHeaderInfoVariant').textContent = variant.title;
    });
});

// listen for add to cart
document.querySelectorAll('.variantUpsellATC')?.forEach(function (element) {
    element.addEventListener("click", async function () {
        element.classList.add("loading");

        // get variant ID from dropdown selector
        let variant = JSON.parse(this.closest('.variantUpsell').querySelector('.variantUpsellOptionsSelect').value);

        let formData = {
            items: [{
                quantity: 1,
                id: variant.id,
            }]
        };

        await addProduct(formData);

        // remove loading animation
        element.classList.remove("loading");

        // close dialog
        this.closest('.variantUpsell').close();
        await openCart();
    });
});

// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}